'use client'

import React from 'react'

interface BootErrorOverlayProps {
  error: string | null
  onReload: () => void
}

const BootErrorOverlay: React.FC<BootErrorOverlayProps> = ({ error, onReload }) => {
  if (!error) return null

  return (
    <div className="fixed inset-0 z-40 flex items-center justify-center bg-black/80 backdrop-blur-sm">
      <div className="bg-red-900/90 border border-red-500/50 rounded-xl p-6 max-w-md mx-4">
        <div className="flex items-center space-x-3 mb-4">
          <div className="w-8 h-8 bg-red-500 rounded-full flex items-center justify-center">
            <span className="text-white text-lg">⚠️</span>
          </div>
          <h3 className="text-lg font-medium text-red-300">Boot Error</h3>
        </div>
        <p className="text-red-200 mb-4">{error}</p>
        <button
          onClick={onReload}
          className="w-full bg-red-600 hover:bg-red-500 text-white px-4 py-2 rounded-lg transition-colors"
        >
          Reload Application
        </button>
      </div>
    </div>
  )
}

export default BootErrorOverlay